import React from 'react';
import './EventList.scss';
import { EventCard } from '../EventCard';
import { EmptyCard } from '../EmptyCard';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setSelectedEvent } from 'store/features/event-slice';

export const EventList = () => {
  const dispatch = useAppDispatch();
  const overdueEvents = useAppSelector(state => state.event.overdueEvents);
  const todaysEvents = useAppSelector(state => state.event.todaysEvents);
  const tomorrowsEvents = useAppSelector(state => state.event.tomorrowsEvents);

  const today = new Date();
  const tomorrow = new Date(new Date(today).setDate(today.getDate() + 1));

  const todaysDate = today.getDate();
  const todaysMonth = today.getMonth() + 1;
  const todaysLabelDate = todaysDate <= 9 ? '0' + todaysDate : todaysDate;
  const todaysLabelMonth = todaysMonth <= 9 ? '0' + todaysMonth : todaysMonth;

  const tomorrowsDate = tomorrow.getDate();
  const tomorrowsMonth = tomorrow.getMonth() + 1;
  const tomorrowsLabelDate = tomorrowsDate <= 9 ? '0' + tomorrowsDate : tomorrowsDate;
  const tomorrowsLabelMonth = tomorrowsMonth <= 9 ? '0' + tomorrowsMonth : tomorrowsMonth;

  return (
    <div className="eventList-container">
      <h2 className="eventList-title">My Schedule</h2>
      <div className="eventList-divider">Overdue</div>
      {overdueEvents.length === 0 ? (
        <EmptyCard text={'You have no overdue events 🙌'} />
      ) : (
        overdueEvents?.map((event, index) => <EventCard key={'overdue-event-' + index} dataId={'overdue-event-' + index} event={event} isOverdue />)
      )}
      <div className="eventList-divider">
        {todaysLabelMonth}-{todaysLabelDate}, Today
      </div>

      {todaysEvents.length === 0 ? (
        <EmptyCard text={'No events today. 🎉'} />
      ) : (
        todaysEvents?.map((event, index) => {
          return (
            <EventCard
              onClick={() => dispatch(setSelectedEvent(event))}
              key={'todays-event-' + index}
              dataId={'todays-event-' + index}
              event={event}
            />
          );
        })
      )}
      <div className="eventList-divider">
        {tomorrowsLabelMonth}-{tomorrowsLabelDate}, Tomorrow
      </div>
      {tomorrowsEvents.length === 0 ? (
        <EmptyCard text={'No events tomorrow. 🎉'} />
      ) : (
        tomorrowsEvents?.map((event, index) => {
          return (
            <EventCard
              onClick={() => dispatch(setSelectedEvent(event))}
              key={'tomorrows-event-' + index}
              dataId={'tomorrows-event-' + index}
              event={event}
            />
          );
        })
      )}
    </div>
  );
};
